export default "__VITE_ASSET__57d6b64c__"